"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyBase = exports.basic = void 0;
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const breakpoints_1 = require("./basic/breakpoints");
const media_1 = require("./basic/media");
const colors_1 = require("./basic/colors");
const spaces_1 = require("./basic/spaces");
const fonts_1 = require("./basic/fonts");
const radii_1 = require("./basic/radii");
const transition_1 = require("./basic/transition");
const icons_1 = require("./basic/icons");
const shadows_1 = require("./basic/shadows");
exports.basic = Object.freeze({
    breakpoints: breakpoints_1.breakpoints,
    media: media_1.media,
    colors: colors_1.colors,
    space: spaces_1.space,
    fontSizes: fonts_1.fontSizes,
    radii: radii_1.radii,
    transition: transition_1.transition,
    shadows: shadows_1.shadows,
    icons: icons_1.icons,
});
exports.applyBase = (0, util_theme_sxc_1.sxApply)(exports.basic);
//# sourceMappingURL=basic.js.map